import React, { PureComponent } from 'react';
import Proptypes from 'prop-types';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

class AssetsFormNotesRowNew extends PureComponent {
  static propTypes = {
    note: Proptypes.shape({
      id: Proptypes.string.isRequired,
      text: Proptypes.string,
      createdBy: Proptypes.shape({
        name: Proptypes.string,
        latname: Proptypes.string,
      }),
    }).isRequired,
  };

  handleRemove = (e) => {
    e && e.preventDefault();
    this.props.handleRemove(this.props.note.id);
  };

  handleModify = (e) => {
    const value = e.target.value;
    this.props.handleModify(this.props.note.id, value);
  };

  render = () => (
    <tr>
      <td className="align-middle">
        <Form.FieldTextArea
          className="mt-3"
          name={'text'}
          handleChange={this.handleModify}
          value={this.props.note.text}
        />
      </td>
      <td className="align-middle">{this.props.t('assets.fields.notes.notSaved')}</td>
      <td className="align-middle">
        {this.props.note.createdBy.name} {this.props.note.createdBy.lastname}
      </td>
      <td className="text-center align-middle">
        <Form.Button
          onClick={this.handleRemove}
          className="btn btn-danger btn-sm"
          text={this.props.t('actions.delete')}
        />
      </td>
    </tr>
  );
}

export default translate()(AssetsFormNotesRowNew);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormNotesRowNew.js